
const borderedPageStyle = {
  borderRadius: 0,
  border: "none",
  boxSizing: "border-box",
  width: "100%",
  flex: 1,
  margin: 0,
  paddingTop: "12px",
  paddingRight: "20px",
  paddingBottom: "20px",
  paddingLeft: "20px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "stretch",
  position: "relative",
  overflow: "auto",
  background: "#f4f3ef",
};

export default function BorderedPage({ children }) {
  return (
    <div style={borderedPageStyle}>
      {children}
    </div>
  );
}